<template>
  <div class="top-bar-wtxh-wrap">
    <div class="top-bar-wtxh">
      <div class="top-bar-left" @click="goHome">
        <img class="site-logo" src="@/assets/m/m-wthd-logo.png" alt="" />
      </div>
      <div class="top-bar-right" @click="navVisible = !navVisible">
        <img class="nav-icon" src="@/assets/m/nav_icon.png" alt="" />
        <span class="nav-text">导航</span>
      </div>
    </div>
    <div class="nav-drawer" v-if="navVisible" @click="navVisible = false">
      <div class="nav-mask"></div>
      <div class="nav-panel" @click.stop>
        <ul class="nav-list" v-if="navigation && navigation.length">
          <li
            v-for="item in navigation"
            :key="item.name"
            @click="goNav(item)"
          >
            <img v-if="item.icon" class="nav-item-icon" :src="item.icon" />
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopBarWtxh",
  props: {
    pageTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      navigation: [],
      navVisible: false,
    };
  },
  mounted() {
    this.getNavigation();
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    getNavigation() {
      this.$axios.post(`/v1/websiteInfo`, { is_pc: 2 }).then((res) => {
        if (res.data && res.data.navigation) {
          this.navigation = res.data.navigation;
        }
      });
    },
    goNav(item) {
      this.navVisible = false;
      if (item.url && item.url.includes("http")) {
        window.location.href = item.url;
      } else if (item.url) {
        this.$router.push(item.url);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.top-bar-wtxh-wrap {
  position: sticky;
  top: 0;
  z-index: 888;
}
.top-bar-wtxh {
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  box-sizing: border-box;
  height: 88px;
  position: relative;
  z-index: 1000;
}
.top-bar-left {
  display: flex;
  align-items: center;
  overflow: hidden;
  flex: 1;
}
.site-logo {
  height: 46px;
  flex-shrink: 0;
  object-fit: contain;
}
.top-bar-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 16px;
}
.nav-icon {
  width: 22px;
  height: 18px;
}
.nav-text {
  margin-left: 8px;
  font-size: 24px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(51, 51, 51, 1);
  line-height: 34px;
}
.nav-drawer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
.nav-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}
.nav-panel {
  position: absolute;
  top: 88px;
  right: 0;
  width: 300px;
  background: #fff;
  border-radius: 0 0 0 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 20px 0;
}
.nav-list {
  li {
    display: flex;
    align-items: center;
    padding: 24px 40px;
    font-size: 28px;
    color: #333;
    &:active {
      background: #f5f5f5;
    }
  }
  .nav-item-icon {
    width: 48px;
    height: 48px;
    margin-right: 20px;
    border-radius: 8px;
  }
}
</style>
